import { render, staticRenderFns } from "./addFilePop.vue?vue&type=template&id=58f7b1b4"
import script from "./addFilePop.vue?vue&type=script&lang=js"
export * from "./addFilePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports